import React from 'react';

import { Model } from '../../../../../../viewer/elements/model';
import { AssetHeader } from '../../components/asset-blocks/asset-header';

type Props = {
  asset: Model;
};

const ModelHeader = (props: Props) => {
  return <AssetHeader asset={props.asset} name={props.asset.name} />;
};

export { ModelHeader, Props as ModelHeaderProps };
